import { ContaRecorrenteParams } from 'core/features/conta-recorrente/typings';
import { OperacaoEnum } from 'core/resources/enums/conta';
import { useCallback, useState } from "react";
import { BaseFiltroPaginate } from "resources/enums/paginate";
import moment from 'moment';


function useFiltroContaRecorrente(operacao: OperacaoEnum, defaultValues?: Partial<ContaRecorrenteParams>) {
  const [filtro, setFiltro] = useState<ContaRecorrenteParams>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    operacao,
    mes: moment().format("YYYY-MM"),
    ...defaultValues,
  });

  const onChangeFiltro = useCallback((_filtro: Partial<ContaRecorrenteParams>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroContaRecorrente;
